import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, CircularProgress, Typography, IconButton, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ImageViewer({ open, imageUrl, onClose }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleOpen = () => {
    setLoading(true);
    setError(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth TransitionProps={{ onEnter: handleOpen }}>
      <DialogTitle sx={{ pr: 6 }}>
        Detection Event Image
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ textAlign: 'center', minHeight: 200, position: 'relative' }}>
          {loading && !error && (
            <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }} />
          )}
          {error ? (
            <Typography color="error" sx={{ py: 4 }}>
              Image could not be loaded. It may have been deleted.
            </Typography>
          ) : imageUrl ? (
            <img
              src={imageUrl}
              alt="Detection event"
              style={{
                maxWidth: '100%',
                maxHeight: '70vh',
                objectFit: 'contain',
                display: loading ? 'none' : 'block',
                margin: '0 auto',
              }}
              onLoad={() => setLoading(false)}
              onError={() => { setLoading(false); setError(true); }}
            />
          ) : null}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
